/**
 * Add the hover class on wrapper when user hovers menu item with dropdown
 */
function addClassOnDropdownHover() {
    const navItemDropdown = document.getElementsByClassName('nav-item dropdown');
    const navbarWrapper = document.querySelector('.c-navbar-wrapper');

    if (navItemDropdown) {
        for (const navItem of Array.from(navItemDropdown)) {
            navItem.addEventListener('mouseover', () => {
                navbarWrapper.classList.add('hover');
            });

            navItem.addEventListener('mouseout', () => {
                navbarWrapper.classList.remove('hover');
            });
        }
    }
}

/**
 * Toggles search popover
 */
function toggleSearch() {
    const searchButton = document.getElementById('toggleSearch');
    const bodyTag = document.querySelector('body');
    const navbarWrapper = document.querySelector('.c-navbar-wrapper');

    if (searchButton) {
        searchButton.addEventListener(returnDeviceSpecificClickEvent(), (e) => {
            bodyTag.classList.toggle('open-search');
            navbarWrapper.classList.toggle('hover');
        });
    }
}

/**
 * Remove toggle states when user clicks on backdrop or when pressing esc key
 */
function removeToggleStates() {
    const backdrop = document.getElementById('backdrop');
    const bodyTag = document.querySelector('body');
    const navbarWrapper = document.querySelector('.c-navbar-wrapper');

    function removeClasses() {
        bodyTag.classList.remove('open-search', 'open-mainmenu');
        navbarWrapper.classList.remove('hover');
    }

    if (backdrop) {
        backdrop.addEventListener(returnDeviceSpecificClickEvent(), (e) => {
            removeClasses();
        });

        document.addEventListener('keydown', (e) => {
            if (e.keyCode === 27) {
                removeClasses();
            }
        });
    }
}

/**
 * Toggle main menu
 */
 function toggleMainMenu() {
    const bodyTag = document.querySelector('body');
    const mainMenuButtons = document.getElementsByClassName('toggleMainmenu');

    if (mainMenuButtons) {
        for (const mainMenuButton of Array.from(mainMenuButtons)) {
            mainMenuButton.addEventListener(returnDeviceSpecificClickEvent(), (e) => {
                if (bodyTag.classList.contains('open-mainmenu')) {
                    bodyTag.classList.remove('open-search');
                    bodyTag.classList.remove('open-mainmenu');
                } else {
                    bodyTag.classList.add('open-mainmenu');
                }
            });
        }
    }
 }

/**
 * Return the device specific click event for mobile/tablet and desktop
 */
function returnDeviceSpecificClickEvent() {
    if ('touchend' in window) {
        return 'touchend';
    } else {
        return 'click';
    }
}

/**
 * Toggle language menu
 */
function toggleLanguageMenu() {
    const toggleLanguage = document.getElementById('toggleLanguage');
    const bodyTag = document.querySelector('body');
    if (toggleLanguage) {
        toggleLanguage.addEventListener(returnDeviceSpecificClickEvent(), (e) => {
            e.target.parentElement.classList.toggle('open');
            bodyTag.classList.toggle('open-language');
        });
    }
}

/**
 * Toggle product sections
 */
function toggleProductSection() {
    const sectionTitles = document.getElementsByClassName('c-product-section--title');

    if (sectionTitles.length > 0) {
        for (const title of sectionTitles) {
            title.addEventListener(returnDeviceSpecificClickEvent(), (e) => {
                const childNodes = e.target.parentNode.children;

                for (const node of childNodes) {
                    node.classList.toggle('show');
                }
            });
        }
    }
}

/**
 * Toggle product sections
 */
function toggleSameAsBilling() {
    var shippingAddress = document.querySelector('#same-as-billing');
    const toggle = () => document.querySelectorAll('#shipping_address').forEach(label => label.classList.toggle('hidden'));

    if (shippingAddress != null) {
        document.querySelector('#same-as-billing').addEventListener('change', (event) => {
            toggle();
        });
        window.addEventListener('DOMContentLoaded', (event) => {
            if (shippingAddress.checked === true) {
                toggle();
            }
        });
    };
}

/**
 * Toggle downloads sections
 */
function toggleDownloads() {
    const downloadsCategories = document.getElementsByClassName('c-product-downloads__category-header');

    if (downloadsCategories.length > 0) {
        for (const category of downloadsCategories) {
            category.addEventListener(returnDeviceSpecificClickEvent(), (e) => {
                e.target.parentElement.classList.toggle('show');
            });
        }
    }
}

export { addClassOnDropdownHover, toggleSearch, returnDeviceSpecificClickEvent, removeToggleStates, toggleMainMenu, toggleLanguageMenu, toggleProductSection, toggleSameAsBilling, toggleDownloads };

// export default function () {
    // var body = document.getElementsByTagName('BODY')[0];
    // var toggleLanguage = document.getElementById('toggleLanguage');
    // var backdrop = document.getElementById('backdrop');
    // var isTouchScreen = false;

    // Check device
    // (function () {
    //     if ('ontouchstart' in document.documentElement) {
    //         isTouchScreen = true;
    //     }
    // })();

    // if (toggleLanguage != null) {
    //     toggleLanguage.addEventListener('click', function () {
    //         this.parentElement.classList.toggle('open');
    //         body.classList.toggle('open-language');
    //     });
    // };

    // if (backdrop != null) {
    //     backdrop.addEventListener('click', function () {
    //         body.classList.remove('open-search');
    //         body.classList.remove('open-mainmenu');
    //     });
    // };

    // if (isTouchScreen) {
    //     document.addEventListener('touchend', function (event) {
    //         toggleNavLink(event);
    //         toggleMainMenu(event);
    //         toggleSearch(event);
    //     });
    // } else {
    //     document.addEventListener('click', function (event) {
    //         toggleNavLink(event);
    //         toggleMainMenu(event);
    //         toggleSearch(event);
    //     });
    // }

    // function toggleNavLink(event) {
    //     if (!event.target.matches('.nav-link-toggle *')) return;
    //     event.preventDefault();
    //     event.target.parentElement.parentElement.classList.toggle('show');
    // }

    // function toggleMainMenu(event) {
    //     if (!event.target.matches('.c-mainmenutoggle__btn')) return;
    //     event.preventDefault();
    //     body.classList.toggle('open-mainmenu');
    //     body.classList.remove('open-search');
    // }

    // function toggleSearch(event) {
    //     if (!event.target.matches('.c-topsearch__btn')) return;
    //     event.preventDefault();
    //     body.classList.toggle('open-search');
    //     body.classList.remove('open-mainmenu');
    //     document.getElementById('SearchTerm').focus();
    // }

    // const activeDropdown = document.querySelectorAll('.c-mainmenu .dropdown.active');

    // if (activeDropdown.length > 0) {
    //     activeDropdown.forEach(function (element) {
    //         element.classList.add('show');
    //     });
    // }
// }
